export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD/CHANGE_PASSWORD_START' as const;
export const CHANGE_PASSWORD_SUCCEED = 'CHANGE_PASSWORD/CHANGE_PASSWORD_SUCCEED' as const;
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD/CHANGE_PASSWORD_FAIL' as const;

export const CLEANUP = 'CHANGE_PASSWORD/CLEANUP' as const;
